// Meta (Facebook/Instagram) Pixel helpers. Browser-only, Pixel ID is public.
// content_ids use the Mongo product _id — the same value used as g:id in the
// Facebook catalog feed, so Pixel events match catalog items for retargeting.

const CURRENCY = "USD";

export function isPixelReady() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

export function track(eventName, params = {}) {
  if (!isPixelReady()) return;
  window.fbq("track", eventName, params);
}

export function trackPageView() {
  track("PageView");
}

export function trackViewContent({ id, name, price }) {
  track("ViewContent", {
    content_ids: [String(id)],
    content_type: "product",
    content_name: name,
    value: Number(price) || 0,
    currency: CURRENCY,
  });
}

export function trackAddToCart({ id, name, price, quantity = 1 }) {
  track("AddToCart", {
    content_ids: [String(id)],
    content_type: "product",
    content_name: name,
    contents: [{ id: String(id), quantity: Number(quantity) }],
    value: (Number(price) || 0) * Number(quantity),
    currency: CURRENCY,
  });
}

export function trackInitiateCheckout(items, total) {
  track("InitiateCheckout", {
    content_ids: items.map((i) => String(i.product_id)),
    content_type: "product",
    contents: items.map((i) => ({ id: String(i.product_id), quantity: Number(i.quantity) })),
    num_items: items.reduce((n, i) => n + Number(i.quantity), 0),
    value: Number(total) || 0,
    currency: CURRENCY,
  });
}

export function trackPurchase({ value, contentIds = [] }) {
  const params = { value: Number(value) || 0, currency: CURRENCY };
  if (contentIds.length) {
    params.content_ids = contentIds.map(String);
    params.content_type = "product";
  }
  track("Purchase", params);
}
